import Bugsnag from '@/plugins/bugsnag'
import { fetchSettings } from './utils/settings'

fetchSettings()
  .then((settings) => {
    Bugsnag.init(settings.ENVIRONMENT)
    return settings
  })
  .then(() => require('./app.js'))
  .catch((err) => console.error(err))
